import apiClient from "../../client/apiClient";
import { appendQueryParams } from "../../utils";

export interface PendingFee {
  feeType: string;
  feeGroup: string;
  amount: number;
  month: string;
  monthKey?: string;
  dueDate: string | null;
}

export interface Defaulter {
  _id: string; 
  enrollmentId: string; 
  enrollmentObjectId?: string; 
  studentId?: string; 
  name: string;
  grNumber?: string;
  contactNo?: string | null;
  class: string;
  section: string;
  classId?: string; 
  sectionId?: string; 
  admissionNumber?: string;
  temporaryGR?: string;
  pendingFees: PendingFee[];
  totalPendingAmount?: number;
  totalFine?: number;
  noticeType?: string;
  noticeNumber?: number;
  // Most recent day this student actually attended. On Eon it comes from a
  // present/late/half-day record; every other campus only writes rows for
  // absences, so there it is the most recent open day with no absence against
  // this student. Null when neither can be established.
  lastAttendanceDate?: string | null;
  // The student's standing (`admitted`, `struck_off`, ...) and its display
  // label. A struck-off student stays on this list because the fees are still
  // owed, so the column has to say which kind of row this is.
  status?: string;
  statusLabel?: string;
}

export interface PaginationData {
  currentPage: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  total: number;
  totalPages: number;
}

export interface DefaultersResponse {
  success: boolean;
  data: Defaulter[];
  pagination: PaginationData;
  count: number;
}

const DEFAULTERS_ENDPOINT = {
  DEFAULT: "/invoice/defaulters",
};

const getDefaulters = async ({
  page = 1,
  limit = 20,
  sortBy,
  sortOrder,
  searchText,
  branchId,
  sessionId,
  classId,
  sectionId,
  systemId,
  feeGroupId,
  status,
}: {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: string;
  searchText?: string;
  branchId?: string;
  sessionId?: string;
  classId?: string;
  sectionId?: string;
  systemId?: string;
  feeGroupId?: string;
  status?: string;
} = {}): Promise<DefaultersResponse> => {
  const response = await apiClient({
    url: appendQueryParams(DEFAULTERS_ENDPOINT.DEFAULT, {
      page,
      limit,
      sortBy,
      sortOrder,
      searchText,
      branch: branchId,
      session: sessionId,
      class: classId,
      section: sectionId,
      system: systemId,
      feeGroup: feeGroupId,
      status,
    }),
    method: "GET",
  });

  return response.data;
};

export {
  getDefaulters,
};